import { toast } from 'react-toastify';
import { call, put, takeEvery } from 'redux-saga/effects';

// Api-Services
import {
  addEmailTemplateApi,
  deleteTemplateApi,
  editEmailTemplateApi,
  emailTemplatesListApi,
  getEmailTemplateByIdApi
} from '../apis/emailTemplates';

// Constants
import {
  GET_EMAIL_TEMPLATES_LIST,
  ADD_EMAIL_TEMPLATE,
  EDIT_EMAIL_TEMPLATE,
  EmailTemplate_GET_DETAILS,
  DELETE_EMAIL_TEMPLATE_REQUEST
} from '../../constants/redux';
import { RESPONSE_STATUS_CODES } from '../../constants/common';

// Redux-Actions
import { apiSuccess } from '../slices/apiStatus';
import {
  addEmailTemplateData,
  deleteTemplate,
  editEmailTemplateDetails
} from '../slices/emailTemplates';

function* emailTemplatesListSaga(action) {
  try {
    const response = yield call(emailTemplatesListApi, {
      ...action.payload
    });
    if (response?.status === RESPONSE_STATUS_CODES.OK) {
      const result = response.data.data;
      const data = result.templates;
      const pagination = result.pagination;
      yield put(addEmailTemplateData({ data, pagination }));
    }
  } catch (error) {
    console.log(error);
  }
}

function* addEmailTemplateSaga(action) {
  try {
    const response = yield call(addEmailTemplateApi, action.payload);
    if (response.status === RESPONSE_STATUS_CODES.OK) {
      toast.success('Email Template Added Successfully', {
        position: toast.POSITION.BOTTOM_RIGHT
      });
      yield put(apiSuccess());
    }
  } catch (error) {
    console.log(error);
  }
}

function* editEmailTemplateData(action) {
  try {
    const response = yield call(editEmailTemplateApi, action.payload);
    if (response.status === RESPONSE_STATUS_CODES.SUCCESS) {
      toast.success('Email Template have been Updated Successfully', {
        position: toast.POSITION.BOTTOM_RIGHT
      });
      yield put(apiSuccess());
    }
  } catch (error) {
    console.log(error);
  }
}

function* deleteTemplateData(action) {
  try {
    const response = yield call(deleteTemplateApi, action.payload);
    if (response?.status) {
      yield put(deleteTemplate(action.payload));
      toast.success('Email Template Deleted Successfully', {
        position: toast.POSITION.BOTTOM_RIGHT
      });
    }
  } catch (error) {
    console.log(error);
  }
}

function* getEmailTemplateByIdSaga(action) {
  const ID = action.payload;
  const response = yield call(getEmailTemplateByIdApi, ID);
  if (response.status === RESPONSE_STATUS_CODES.OK) {
    console.log(response.data.data, 'hgjhg');
    const TemplateDetails = response.data.data.emailTemplate;
    const fieldDetails = response.data.data.fieldMappings;
    yield put(editEmailTemplateDetails({ TemplateDetails, fieldDetails }));
    yield put(apiSuccess());
  }
}

export default function* watcherTechnologySaga() {
  yield takeEvery(GET_EMAIL_TEMPLATES_LIST, emailTemplatesListSaga);
  yield takeEvery(ADD_EMAIL_TEMPLATE, addEmailTemplateSaga);
  yield takeEvery(EDIT_EMAIL_TEMPLATE, editEmailTemplateData);
  yield takeEvery(DELETE_EMAIL_TEMPLATE_REQUEST, deleteTemplateData);
  yield takeEvery(EmailTemplate_GET_DETAILS, getEmailTemplateByIdSaga);
}
